const fr: Record<string, string> = {
  'features.groceries.empty': 'Aucune liste de courses pour le moment. Programmez-en une pour commencer.',
  'features.groceries.newList': 'Nouvelle liste',
  'features.groceries.listName': 'Nom',
  'features.groceries.listNamePlaceholder': 'ex. Courses de la semaine',
  'features.groceries.scheduledDate': 'Date prévue',
  'features.groceries.noScheduledDate': 'Pas encore de date',
  'features.groceries.assignedTo': 'Assignée à',
  'features.groceries.noAssignee': 'Personne pour le moment',
  'features.groceries.forceOnDashboard': 'Toujours afficher sur le tableau de bord',
  'features.groceries.cancel': 'Annuler',
  'features.groceries.create': 'Créer',
  'features.groceries.planned': 'Prévue',
  'features.groceries.done': 'Terminée',
  'features.groceries.passed': 'Passée',
  'features.groceries.editList': 'Modifier la liste',
  'features.groceries.defaultListTitle': 'Prochaines courses',
  'features.groceries.remainingCount': '{{count}} article(s) sur {{total}} restant(s)',
  'features.groceries.noItems': 'Aucun article pour le moment.',
  'features.groceries.showPickedUpItems': 'Afficher les articles pris',
  'features.groceries.hidePickedUpItems': 'Masquer les articles pris',
  'features.groceries.allPickedUpHidden': 'Tous les articles sont pris et masqués. Réaffichez-les depuis le menu de l’onglet.',
  'features.groceries.editItems': 'Modifier les articles',
  'features.groceries.viewCatalog': 'Catalogue',
  'features.groceries.backToLists': 'Retour aux listes',
  'features.groceries.backToList': 'Retour aux courses',
  'features.groceries.shoppingMode': 'Mode courses',
  'features.groceries.configureSections': 'Configurer les rayons',
  'features.groceries.doneConfiguringSections': 'Terminer la configuration des rayons',
  'features.groceries.markFavorite': 'Marquer comme favorite',
  'features.groceries.unmarkFavorite': 'Retirer des favorites',
  'features.groceries.archiveList': 'Archiver la liste',
  'features.groceries.restoreList': 'Restaurer la liste',
  'features.groceries.showArchivedLists': 'Afficher les archivées ({{count}})',
  'features.groceries.hideArchivedLists': 'Masquer les archivées',
  'features.groceries.copyFromFavorite': 'Reprendre le contenu d’une liste favorite',
  'features.groceries.copyFromFavoriteNone': 'Ne rien copier',
  'features.groceries.mealSuggestionsTitle': 'Suggéré par les repas à venir',
  'features.groceries.addFromMeals': 'Ajouter depuis les repas',
  'features.groceries.noMealSuggestions': 'Aucune suggestion de repas pour le moment.',
  'features.groceries.showCatalog': 'Afficher le catalogue',
  'features.groceries.hideCatalog': 'Masquer le catalogue',
  'features.groceries.mealsAccountedFor': 'Repas pris en compte dans cette liste',
  'features.groceries.mealAccountedForHeadcount': '{{count}}p.',
  'features.groceries.mealSuggestionSubtitle': '{{recipe}} — {{meal}}, {{date}}, {{count}} personnes',
  'features.groceries.addAllSuggestion': 'Tout ajouter',
  'features.groceries.addAccompanimentSuggestion': 'Ajouter',
  'features.groceries.accompaniments': 'Accompagnements',
  'features.groceries.removeAddedMeal': 'Retirer de cette liste',
  'features.groceries.removeAddedMealConfirm': 'Retirer « {{recipe}} » ({{date}}) de cette liste ? Les articles déjà ajoutés restent sur votre liste — seul le repas ne sera plus pris en compte.',
  'features.groceries.catalog': 'Catalogue',
  'features.groceries.catalogEmpty': 'Aucun article au catalogue. Ajoutez un rayon, puis un article.',
  'features.groceries.filterItemsPlaceholder': 'Filtrer les articles…',
  'features.groceries.filterNoResults': 'Aucun article ne correspond à votre filtre.',
  'features.groceries.myList': 'Ma liste',
  'features.groceries.uncategorized': 'Sans rayon',
  'features.groceries.addSection': 'Ajouter un rayon',
  'features.groceries.sectionName': 'Nom du rayon',
  'features.groceries.sectionNamePlaceholder': 'ex. Boucherie',
  'features.groceries.isFoodSection': 'Rayon alimentaire',
  'features.groceries.isFoodSectionHelp': "Affiché lors du choix des ingrédients d'une recette.",
  'features.groceries.isCondimentSection': 'Rayon condiments',
  'features.groceries.isCondimentSectionHelp': "Les ingrédients de ce rayon s'affichent à part, à côté de la recette.",
  'features.groceries.addItemToSection': 'Ajouter un article à ce rayon',
  'features.groceries.addingToSection': 'Ajout dans :',
  'features.groceries.renameSection': 'Renommer le rayon',
  'features.groceries.moveSectionUp': 'Déplacer le rayon vers le haut',
  'features.groceries.moveSectionDown': 'Déplacer le rayon vers le bas',
  'features.groceries.deleteSection': 'Supprimer le rayon',
  'features.groceries.deleteSectionMessage': 'Supprimer le rayon « {{name}} » ?',
  'features.groceries.save': 'Enregistrer',
  'features.groceries.manageItem': "Modifier l'article",
  'features.groceries.suggestions': 'À racheter bientôt',
  'features.groceries.archiveItem': "Archiver l'article",
  'features.groceries.iconLabel': 'Icône',
  'features.groceries.sectionsLabel': 'Rayons',
  'features.groceries.noSectionsYet': 'Aucun rayon pour le moment.',
  'features.groceries.newItem': 'Nouvel article',
  'features.groceries.newItemName': "Nom du nouvel article",
  'features.groceries.newItemNamePlaceholder': 'ex. Tomates',
  'features.groceries.unitLabel': 'Unité',
  'features.groceries.unit.gram': 'Gramme',
  'features.groceries.unit.gram_other': 'Grammes',
  'features.groceries.unit.kg': 'Kg',
  'features.groceries.unit.kg_other': 'Kg',
  'features.groceries.unit.piece': 'Pièce',
  'features.groceries.unit.piece_other': 'Pièces',
  'features.groceries.unit.liter': 'Litre',
  'features.groceries.unit.liter_other': 'Litres',
  'features.groceries.unit.none': 'Aucune',
  'features.groceries.unit.none_other': 'Aucune',
  'features.groceries.isDivisible': 'Peut être pris en quantité fractionnée',
  'features.groceries.renewalDays': 'Fréquence de réapprovisionnement (jours)',
  'features.groceries.renewalDaysHelp': "À quelle fréquence vous rachetez cet article — sert à vous le suggérer dans vos prochaines listes.",
  'features.groceries.renewalDaysPlaceholder': 'Non suivi',
  'features.groceries.suggestedQuantity': 'Quantité suggérée',
  'features.groceries.suggestedQuantityHelp': "Préremplit la quantité lorsque vous ajoutez cet article à une liste.",
  'features.groceries.suggestedQuantityPlaceholder': 'Non définie',
  'features.groceries.itemComment': 'Commentaire',
  'features.groceries.itemCommentPlaceholder': 'Ajouter une note pour cet article…',
  'features.groceries.addCustomItem': 'Ajouter un article ponctuel',
  'features.groceries.customItemName': "Nom de l'article",
  'features.groceries.customItemNamePlaceholder': 'ex. Sacs poubelle',
  'features.groceries.customItemUnit': 'Unité (optionnel)',
  'features.groceries.customItemUnitPlaceholder': 'ex. rouleaux',
};

export default fr;
